import React from "react";

export default function ProductAlertBar() {
  return (
    <>
      <div className="pab-bar">
        <span className="pab-label">Attention:</span>
        <span>
          Classification Route B du produit certifies,
        </span>
        <span className="pab-line"></span>
        <span>
          certaines pièces du dossier dorcier pourraient être compenelaites.
        </span>
      </div>

      <style>{`
        .pab-bar {
          margin-top: 16px;
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 16px;
          border-radius: 12px;
          background: linear-gradient(180deg, rgba(126,89,50,0.30), rgba(98,63,36,0.22));
          border: 1px solid rgba(196, 144, 79, 0.24);
          color: #f2e5d3;
          font-size: 14px;
          flex-wrap: wrap;
        }

        .pab-label {
          font-weight: 700;
          color: #ffc785;
        }

        .pab-line {
          display: inline-block;
          width: 42px;
          height: 2px;
          border-radius: 999px;
          background: rgba(255,255,255,0.30);
        }
      `}</style>
    </>
  );
}